import { generateFiltersFactory } from './factories';
import { formatCoordinates } from './helpers';

const filtersAdapter = (market: string, payload: any) => {
  const { garages, bedrooms, suites, inputIntervals } = payload;

  const realtyProgram = {
    garages: garages,
    bedrooms: bedrooms,
    suites: suites,
  };

  return generateFiltersFactory(inputIntervals, market, realtyProgram);
};

export const generalMarketsPayloadAdapter = (
  payload: any,
  cityId: string | number,
  market: string
) => {
  const filters = filtersAdapter(market, payload);
  const realtyTypeFilter = payload?.realtyType?.name?.toLowerCase();
  const coordinatesData = formatCoordinates(payload?.location?.coordinates);
  const adType = payload?.adType;
  const circle_search = payload?.location?.radius && {
    radius: payload?.location?.radius,
    lat: payload?.location?.coordinates[0][0],
    lon: payload?.location?.coordinates[0][1],
  };
  const areaToSearch = circle_search
    ? { circle_search }
    : { coordinates: [coordinatesData] };
  return {
    city_id: Number(cityId),
    realty_type: realtyTypeFilter,
    ad_type: adType,
    ...areaToSearch,
    ...filters,
  };
};
